import { useMemo, useCallback } from 'react';
import { useAuth } from '../contexts/AuthContext';
import {
  resolveUserPermissions,
  hasPermission as checkPermission,
  getRequiredPermissionForPath,
} from '../constants/permissions';

/**
 * Permissões derivadas do usuário (GET /profile: roles → catálogo; ou permissions explícitas).
 */
export function usePermissions() {
  const { user } = useAuth();

  const permissions = useMemo(() => resolveUserPermissions(user), [user]);

  const hasPermission = useCallback(
    (required) => checkPermission(permissions, required),
    [permissions]
  );

  const canAccessPath = useCallback(
    (pathname) => {
      const required = getRequiredPermissionForPath(pathname);
      return checkPermission(permissions, required);
    },
    [permissions]
  );

  return {
    permissions,
    hasPermission,
    canAccessPath,
  };
}
